<template>
    <div id="PayConfirm"  v-wechat-title="this.title">
        <div class="pc-top">
            <Steps :current="current">
                <Step title="立即购买"></Step>
                <Step title="提交订单"></Step>
                <Step title="选择支付方式"></Step>
                <Step title="支付成功"></Step>
            </Steps>
        </div>
        <div class="pc-main">
            <div class="row" style="overflow: hidden;width: 100%">
                <div class="dv_title">收货地址</div>

                <div class="dv_address address_unsel" v-for="(item , key) in addrList"
                     :key="key"
                     :class="item.active==1?'address_sel':''"
                     @mouseover="mouseOver(item)"
                     @mouseleave="mouseLeave(item)"
                >
                    <table style="border-collapse:collapse;color:#222;width:195px;height:100px;margin:10px 0 0 12px;" boreder="0">
                        <tr>
                            <td align="left" style="height:24px;" valign="top">{{ item.consignee }}</td>
                            <td align="right" valign="top">{{ item.phone }}</td>
                        </tr>
                        <tr>
                            <td colspan="2" align="left" style="height:27px;">
                                <div style="height:18px;overflow:hidden;word-break:break-all;word-wrap:break-word;">{{ item.province_name }} {{ item.city_name }} {{ item.county_name }}</div>
                                <div style="height:18px;overflow:hidden;word-break:break-all;word-wrap:break-word;">{{ item.address }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="left" :class="item.move==1?'':'hide'">
                                <a class="edit_a" href="javascript:void(0);" style="color: rgb(238, 53, 49);" @click="edit(item,key)" >编辑</a>
                                <a class="edit_a" href="javascript:void(0);" style="color: rgb(238, 53, 49); margin-left: 8px;" @click="del(item,key)">删除</a>
                                <a class="edit_a" id="edit_default" href="javascript:void(0);" style="color: rgb(238, 53, 49); margin-left: 8px;" v-if="item.default==1">默认</a>
                                <a class="edit_a" id="edit_default" href="javascript:void(0);" style="color: rgb(238, 53, 49); margin-left: 8px;" @click="defaults(item)" v-else>设为默认</a>
                            </td>
                        </tr>
                    </table>
                </div>

                <div @click="addAddr" class="dv_address address_unsel " style="line-height:110px;" aid="0"><span style="font-weight:800;font-size:16px;">+</span>新增收货地址</div>
            </div>
            <div class="dv_title" style="margin-top:50px;">商品信息</div>

            <table style="width:100%;border-collapse:collapse;color:#666;border:1px solid #eee;margin-top:30px;">
                <tbody>
                <tr>
                    <td style="width:510px;height:30px;" class="td_title">商品信息</td>
                    <td style="width:150px;" class="td_title">单价</td>
                    <td style="width:150px;" class="td_title">数量</td>
                    <td style="width:150px;" class="td_title">小计</td>
                </tr>
                <tr style="color:#000;">
                    <td style="padding:15px;">
                        <img :src="entity_image" style="height:50px;margin-left:15px;float:left;">
                        <div style="height:50px;line-height:50px;float:left;margin-left:10px;font-size:14px;">{{name}}</div>
                    </td>
                    <td style="text-align:center;">￥69</td>
                    <td>
                        <InputNumber :max="100" :min="1" v-model="num" @change="num"></InputNumber>
                    </td>
                    <td style="text-align:center;">￥<span class="dv_ap">{{ money }}</span></td>
                </tr>
                </tbody>
            </table>

            <table style="width:500px;border-collapse:collapse;float:right;margin-top:10px;" border="0">
                <tbody>
                <tr>
                    <td style="color:#666;padding:8px;" align="right">商品总额：</td>
                    <td style="width:50px;color:#333;font-size:14px;font-weight:900;" align="right">￥<span class="dv_ap">{{ money }}</span></td>
                </tr>
                <tr>
                    <td style="color:#666;padding:8px;" align="right">运费：</td>
                    <td style="color:#333;font-size:14px;font-weight:900;" align="right">￥<span id="dv_fee">0</span></td>
                </tr>
                <tr>
                    <td style="color:#666;padding:15px 8px;font-size:14px;" align="right">应付总额：</td>
                    <td style="color:#EE3531;font-size:24px;font-weight:400;" >￥<span id="dv_app">{{ money }}</span></td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div id="sj_pay" style="width:160px;height:40px;line-height:40px;background:#EE3531;color:#fff;font-size:16px;text-align:center;border:1px solid #EE3531;border-radius:3px;margin-top:15px;cursor:pointer;float:right;">提交订单</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal title="添加地址" v-model="modal" :maskClosable="false"  ref="modal" width="400">
            <div class="ivu-modal-confirm-body" style="padding:0 20px;">
                <Cascader class="m-input" v-model="address" :data="data" :load-data="loadData" placeholder="请选择省市区"></Cascader>
                <input type="hidden" v-model="aid" />
                <Input class="m-input" v-model="addrDesc" placeholder="详细地址" />
                <Input class="m-input" v-model="addrName" placeholder="收货人" />
                <Input class="m-input" v-model="addrPhone" placeholder="收货人电话" />
                <span style="margin-right: 10px;">默认地址</span> <i-Switch v-model="defaultC" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="modalCancel">取消</Button>
                <Button type="primary" size="large" @click="addressCif" :loading="modalLoading">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import goodsApi from "@/api/goods.js";
    export default {
        name: "PayConfirm",
        data(){
            return {
                title:'填写收货地址',
                data: [],
                aid:0,
                address:[],
                addrDesc:'',
                addrPhone:'',
                addrName:'',
                defaultC:false,
                editAddrIndex:0,
                num:1,
                pid:0,
                price:0,
                name:'',
                entity_image:'',
                current :1,
                modal :false,
                modalLoading :false
            }
        },
        computed :{
            money(){ return  this.price*this.num;},
            addrList(){
                return this.$store.getters.getAddrList;
            }
        },
        methods:{
            addAddr(){
                this.editAddrIndex = 0;
                this.aid = 0;
                this.address =  [];
                this.addrDesc = '';
                this.addrName = '';
                this.addrPhone = '';
                this.defaultC = false;
                this.modal = true;
            },
            modalCancel(){
                this.modal = false;
            },
            loadData (item, callback) {
                item.loading = true;
                let pid = item.value;
                goodsApi.getArea(pid).then(function(response){
                    if(response.code == 200){
                        item.children = response.data;
                        item.loading = false;
                        callback();
                    }
                });
            },
            mouseOver(item) {
                item.move = 1;
            },
            mouseLeave(item) {
                item.move = 0;
            },
            edit(item,index){
                this.editAddrIndex = index;
                this.aid = item.id;
                let cityArr = [item.province,item.city];
                if(item.county!=0){
                    cityArr.push(item.county);
                }
                this.address = cityArr;
                this.addrDesc =item.address;
                this.addrName =item.consignee;
                this.addrPhone =item.phone;
                this.defaultC =item.default==1?true:false;
                this.modal = true;
            },
            del(item,index){
                let token = this.$store.getters.getToken;
                let delData = {aid:item.id,index:index,token:token};
                this.$store.dispatch("delAddress",delData);
            },
            defaults(item){
                this.$store.dispatch('editAddr',{aid:item.id,'default':0,active:0});
                item.default = 1;
                item.active = 1;

            },
            addressCif(){
                let updateArr = {
                    province:this.address[0],
                    city:this.address[1],
                    address:this.addrDesc,
                    consignee:this.addrName,
                    phone:this.addrPhone,
                    default:this.defaultC?1:0,
                    token:this.$store.getters.getToken,
                };
                if( this.address[2]!=undefined ){
                    updateArr.county = this.address[2];
                }
                if(this.aid==0){
                    let $this = this;
                    this.$store.dispatch("addAddress",updateArr).then(()=>{
                        $this.modal = false;
                    });
                }else{
                    updateArr.aid = this.aid;
                }
            }
        },
        mounted(){
            let data = this.$store.getters.getShopDetail;
            this.price = parseInt(data.price);
            this.name = data.entity_name;
            this.entity_image = data.entity_image;
            this.num = parseInt(this.$route.query.num);
            this.pid = this.$route.query.pid;
            let obj = this;
            let token = obj.$store.getters.getToken;
            this.$store.dispatch('getAddress',token);
            goodsApi.getArea(0).then(function(response){
                if(response.code == 200){
                    obj.data = response.data;
                    obj.$LoadingBar.finish();
                }
            });
        },
    }
</script>

<style scoped>
    #PayConfirm{
        width: 100%;
        overflow: hidden;
        text-align: left;
    }
    .pc-top{
        width: 100%;
        margin: 50px 0;
        padding: 0 20%;
    }
    .pc-main{
        width: 100%;
        margin: 10px 0;
        padding: 0 20%;
    }
    .dv_title {
        font-size: 15px;
        font-weight: bold;
        width: 100%;
        height: 22px;
        line-height: 22px;
        color: #000;
    }
    .address_unsel {
        background: url('https://www.dalongyun.com/static/images/shop/addr.png');
    }
    .dv_address {
        width: 220px;
        height: 110px;
        text-align: center;
        margin: 15px 25px 0 0;
        color: #666;
        float: left;
        cursor: pointer;
    }
    .address_sel {
        background: url('https://www.dalongyun.com/static/images/shop/add_current.png');
    }
    .td_title {
        background: #f6f6f6;
        text-align: center;
        border-bottom: 1px solid #eee;
    }

    .m-input{
        margin: 10px 0;
    }
    .hide{
        display: none;
    }
</style>